// extracted by mini-css-extract-plugin
module.exports = {"tableHead":"Table_tableHead__-p9jU","bigColWidth":"Table_bigColWidth__1hnz8","biggerColWidth":"Table_biggerColWidth__3uBMv","row":"Table_row__183xH","col":"Table_col__36ZLL"};